import * as angular from "angular";
import {IController} from "angular";

export class notificationsConfigurationCtrl implements IController {

  isSupply?: boolean;

  private currentNavItem: any;

  /* @ngInject */
  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  }

}

angular
  .module('bringoz.admin.notifications')
  .component('notificationsConfiguration', {
    bindings: {
      isSupply: '<?'
    },
    template: require('./notifications-configuration.html').default,
    controller: notificationsConfigurationCtrl
  });
